import { render, staticRenderFns } from "./modelChoose.vue?vue&type=template&id=9ae946e6&scoped=true&"
import script from "./modelChoose.vue?vue&type=script&lang=js&"
export * from "./modelChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae946e6",
  null
  
)

export default component.exports